import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 8v8","key":"svg-0"}],["path",{"d":"M12 3c7.2 0 9 1.8 9 9c0 7.2 -1.8 9 -9 9c-7.2 0 -9 -1.8 -9 -9c0 -7.2 1.8 -9 9 -9","key":"svg-1"}]]

const IconSquareRoundedLetterI = createReactComponent('outline', 'square-rounded-letter-i', 'SquareRoundedLetterI', __iconNode);

export default IconSquareRoundedLetterI;